import type { BrandSteps } from 'apiTypes/BrandSteps'

export enum StepType {
	Introduction = 'INTRODUCTION',
	Terms = 'TERMS',
	Accounts = 'ACCOUNTS',
	MissingOtherApplicant = 'MISSING_OTHER_APPLICANT',
	Assets = 'ASSETS',
	BudgetEditForm = 'BUDGET_EDIT_FORM',
	BudgetPoll = 'BUDGET_POLL',
	Success = 'SUCCESS',
	/** Conceptually this is a silly step, but the handler expects a returned step so we need a step to show something
	 * while redirecting the user. Showing the finished step while the redirect is happening is a bit jarring. */
	Redirect = 'REDIRECT',
}

export type Step =
	| { type: StepType.Introduction; brandSteps: Array<BrandSteps> }
	| { type: StepType.Terms }
	| { type: StepType.Accounts; isBankDataReceived: boolean }
	| { type: StepType.MissingOtherApplicant; isBankDataPending: boolean }
	| { type: StepType.Assets }
	| { type: StepType.BudgetEditForm }
	| { type: StepType.BudgetPoll }
	| { type: StepType.Success }
	| { type: StepType.Redirect; redirectUrl: string }
